import { render } from "./MlServer_autoanno.vue?vue&type=template&id=6e40ae21&scoped=true"
import script from "./MlServer_autoanno.vue?vue&type=script&lang=js"
export * from "./MlServer_autoanno.vue?vue&type=script&lang=js"

import "./MlServer_autoanno.vue?vue&type=style&index=0&id=6e40ae21&lang=scss&scoped=true"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e40ae21"]])

export default __exports__